import { epochToDate } from "@/utils/dateUtils";

import type { Notification } from "@/pages/notifications/types";

export interface NotificationGroup<T> {
  label: string;
  items: T[];
}

// Buckets by calendar day (Today/Yesterday/Earlier), dropping empty groups.
export function groupByRecency<T extends Notification>(
  notifications: T[]
): NotificationGroup<T>[] {
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);

  const groups: NotificationGroup<T>[] = [
    { label: "Today", items: [] },
    { label: "Yesterday", items: [] },
    { label: "Earlier", items: [] },
  ];

  notifications.forEach((n) => {
    const created = n.created_on ? epochToDate(n.created_on) : null;
    if (created && created >= todayStart) {
      groups[0].items.push(n);
    } else if (created && created >= yesterdayStart) {
      groups[1].items.push(n);
    } else {
      groups[2].items.push(n);
    }
  });

  return groups.filter((g) => g.items.length > 0);
}
